// @ts-nocheck
import React, { useState, useEffect } from "react";
import { Container, Alert } from "react-bootstrap";
import PageLoading from "components/PageLoading";
import { useForm } from "../../../../../../context/FormContext";
import SaveSubmitButtons from "../../../../../../components/SaveSubmitButtons/SaveSubmitButtons";
import ConfirmacaoDocumentacao from "../../../../../../components/ConfirmacaoDocumentacao/ConfirmacaoDocumentacao";
import Topic from "./Topic";
import { salvarRespostaComArquivos } from "../../../../../../services/respostaService";
import "./DocBonusExtraTab.css";
import { getDocumentosByRespostaId } from "../../../../../../services/documentoService";
import NotificationToast from "../../../../../../components/NotificationToast/NotificationToast";
import { forwardRef, useImperativeHandle } from "react";
import { getHistoricoAnalise } from "../../../../../../services/analiseService";
import { enviarAdequacao } from "../../../../../../services/adequacaoService";

export interface DocBonusExtraTabProps {
  isActive?: boolean;
  setActiveTab?: React.Dispatch<React.SetStateAction<string>>;
  resposta?: unknown;
  documentos?: unknown[];
  sindicatoData?: unknown;
  openByTopic?: Record<string, boolean>;
  onToggleOne?: (idCampoJson: string) => void;
  onTopicsLoaded?: (topics: { idCampoJson: string }[]) => void;
  showToggleAll?: boolean;
  isAllOpen?: boolean;
  onToggleAll?: () => void;
}

export interface DocBonusExtraTabRefHandle {
  handleSave?: () => Promise<{ show?: boolean; message?: string; type?: string }>;
}

const DocBonusExtraTab = forwardRef<DocBonusExtraTabRefHandle, DocBonusExtraTabProps>(
  (
    {
      isActive,
      setActiveTab,
      resposta,
      documentos,
      sindicatoData,
      openByTopic = {},
      onToggleOne,
      onTopicsLoaded,
      showToggleAll = false,
      isAllOpen = false,
      onToggleAll,
    },
    ref,
  ) => {
    const { updateFormData, formData } = useForm();
    const [, setReceitaOperacional] = useState(0);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [errors, setErrors] = useState({});
    const [selectedOptions, setSelectedOptions] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [topics, setTopics] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [idResposta, setIdResposta] = useState(null);
    const [fullJson, setFullJson] = useState(null);
    const [formDisabled, setFormDisabled] = useState(false);
    const [, setPerfilUsuario] = useState({
      responsavelPreenchimento: "",
      cargoResponsavel: "",
    });
    const [toastData, setToastData] = useState({
      show: false,
      message: "",
      type: "",
    });
    const [historicoAnalise, setHistoricoAnalise] = useState<Record<string, unknown>>({});
    const [showAdequacaoButton, setShowAdequacaoButton] = useState(false);
    const [podeEditar, setPodeEditar] = useState(false);
    const [dataFim, setDataFim] = useState(false);
    const [dadosCadastros, setDadosCadastros] = useState();

    const extrairRespostasDoTema = (criterios) => {
      const _paths = {};
      let respostaRaiz = "";

      let respostaCriterio1 = "";
      let respostaNivel1 = "";
      let respostaNivel2 = "";
      let respostaNivel3 = "";
      let index = 0;
      let arrayTeste = [];

      const percorrerCampos = (campos, path = []) => {
        campos?.forEach((campo) => {
          if (campo.tipoCampo === "radio") {
            const respostaAtual = campo.resposta;

            if (criterios.length > 1) {
              if (campo.idCampo === "cumprir-acao-internacional") {
                respostaCriterio1 = campo.resposta;
              }
              if (
                campo.idCampo === "tipo-acao-internacional" &&
                respostaAtual !== ""
              ) {
                respostaNivel1 = respostaAtual;
                path = [respostaAtual];
                arrayTeste[index] = respostaAtual;
                index++;
              }
              if (
                campo.idCampo === "missoes-ao-exterior" &&
                respostaAtual !== ""
              ) {
                respostaNivel2 = respostaAtual;
                path = [respostaAtual];
                arrayTeste[index] = respostaAtual;
                index++;
              }
              if (
                campo.idCampo === "assesoria-e-facilitacao" &&
                respostaAtual !== ""
              ) {
                respostaNivel2 = respostaAtual;
                path = [respostaAtual];
                arrayTeste[index] = respostaAtual;
                index++;
              }
              if (
                campo.idCampo === "participacao-empresas-associadas" &&
                respostaAtual !== ""
              ) {
                respostaNivel3 = respostaAtual;
                path = [respostaAtual];
                arrayTeste[index] = respostaAtual;
                index++;
              }

              if (respostaCriterio1 === "SIM") {
                campo.alternativa?.forEach((alt) => {
                  if (alt.campo) {
                    const chaveAlt = alt.valor || alt.titulo;
                    percorrerCampos(alt.campo, [...path, chaveAlt]);
                  }
                });
              }
            } else {
              if (path.length === 0) {
                respostaRaiz = respostaAtual;
              }
            }
          }
        });
      };

      criterios.forEach((criterio) => percorrerCampos(criterio.campo));

      if (criterios.length > 1) {
        respostaRaiz = respostaCriterio1;
      }

      var paths2 = {};
      for (let index = 0; index < arrayTeste.length; index++) {
        let element = arrayTeste[index];

        if (respostaNivel1 === element) {
          paths2[respostaNivel1] = respostaNivel1;
        } else if (respostaNivel2 === element) {
          paths2[respostaNivel1 + "." + respostaNivel2] = respostaNivel2;
        } else if (respostaNivel3 === element) {
          paths2[respostaNivel1 + "." + respostaNivel2 + "." + respostaNivel3] =
            respostaNivel3;
        }
      }

      return {
        resposta: respostaRaiz,
        caminhos: paths2,
      };
    };

    useEffect(() => {
      if (!isActive || !resposta) return;

      setIsLoading(true);

      const rawJson = resposta.data?.json;
      const json = typeof rawJson === "string" ? JSON.parse(rawJson) : rawJson;
      const id = resposta.data?.id;
      const temas = json?.docsBonusExtra?.[0]?.tema || [];

      const normalizarTitulo = (titulo) => {
        let tituloNormalizado = titulo
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^\w\s-]/g, "")
          .replace(/^\d+\s*[-.]*\s*/, "")
          .trim()
          .replace(/\s+/g, "-");

        if (tituloNormalizado === "dre---demonstracoes-do-resultado") {
          tituloNormalizado = "dre-demonstracoes-do-resultado";
        }

        if (
          tituloNormalizado ===
          "defesa-de-interesse-implementada-no-executivo-ou-legislativo"
        ) {
          tituloNormalizado =
            "defesa-de-interesse-implementada-no-executivo-e-legislativo";
        }

        return tituloNormalizado;
      };

      const parsedTopics = temas.map((tema, index) => {
        const tituloNormalizado = normalizarTitulo(tema.titulo);

        let idCampoJson = tituloNormalizado;
        if (
          idCampoJson ===
          "defesa-de-interesse-implementada-no-executivo-ou-legislativo"
        ) {
          idCampoJson =
            "defesa-de-interesse-implementada-no-executivo-e-legislativo";
        }

        return {
          id: index + 1,
          idCampoJson,
          title: tema.titulo,
          description:
            tema.criterio?.find((c) => c?.titulo)?.titulo ||
            tema.criterio?.find((c) => c?.campo?.some((campo) => campo?.titulo))
              ?.campo?.[0]?.titulo ||
            tema.descricao ||
            "",
          criterios: tema.criterio || [],
          link: tema.link || null,
        };
      });

      let respostaData = resposta.data;
      setDadosCadastros(respostaData);

      const extrairNomeBase = (nomeArquivo) => {
        return nomeArquivo
          ?.toLowerCase()
          .replace(/-?\d{4}(-\d+)?/i, "")
          .replace(/-v\d+/i, "")
          .replace(/\.(pdf|xlsx)$/i, "")
          .trim();
      };

      const extrairVersao = (nomeArquivo) => {
        const match = nomeArquivo.match(/-v(\d+)/i);
        return match ? parseInt(match[1], 10) : 1;
      };

      const arquivosPorCampo = {};
      documentos?.forEach((doc) => {
        const nomeBase = extrairNomeBase(doc.nomeArquivo);
        const versao = extrairVersao(doc.nomeArquivo);

        if (!nomeBase) return;

        if (!arquivosPorCampo[nomeBase]) arquivosPorCampo[nomeBase] = [];
        arquivosPorCampo[nomeBase].push({ ...doc, versao });
      });

      const arquivosSelecionados = {};
      Object.entries(arquivosPorCampo).forEach(([campo, arquivos]) => {
        const arquivoMaisAtual = arquivos.sort(
          (a, b) => b.versao - a.versao
        )[0];
        arquivosSelecionados[campo] = [arquivoMaisAtual];
      });

      const selected = {};
      temas.forEach((tema, index) => {
        const topicId = index + 1;
        selected[topicId] = extrairRespostasDoTema(tema.criterio);
      });

      const carregarHistorico = async () => {
        try {
          const responseHistorico = await getHistoricoAnalise(id);

          const historico =
            responseHistorico?.historicoAnaliseAdequacaoCampoQuestionarioJson;

          if (Array.isArray(historico) && historico.length > 0) {
            const historicoMap = {};
            historico.forEach((item) => {
              if (item.idCampoJson) {
                historicoMap[item.idCampoJson] = {
                  ...item,
                  idCampoJson: item.idCampoJson,
                };
              }
            });

            setHistoricoAnalise(historicoMap);
            VerificarSePodeEditar(historicoMap);
          } else {
            setHistoricoAnalise({});
            VerificarSePodeEditar({});
          }
        } catch (error) {
          console.error("❌ Erro ao carregar histórico:", error);
          setHistoricoAnalise({});
          VerificarSePodeEditar({});
        }
      };

      const arquivosSalvos = formData?.docBonusExtra?.uploadedFiles || {};
      const arquivosCompletos = {};
      const todosCampos = new Set([
        ...Object.keys(arquivosSelecionados),
        ...Object.keys(arquivosSalvos),
      ]);

      todosCampos.forEach((campo) => {
        const doBanco = arquivosSelecionados[campo] || [];
        const daSessao = arquivosSalvos[campo] || [];

        const combinados = [
          ...doBanco,
          ...daSessao.filter(
            (sessao) =>
              !doBanco.some((db) => db.identificador === sessao.identificador)
          ),
        ];

        arquivosCompletos[campo] = combinados;
      });

      const VerificarSePodeEditar = (historico = null) => {
        try {
          const podeEditarLocal = resposta.data.prazoEdicao;
          const datafim = resposta.data.dataFim;

          const rawJson2 = resposta.data?.json;
          const json2 =
            typeof rawJson2 === "string" ? JSON.parse(rawJson2) : rawJson2;

          const temasAba = json2?.docsBonusExtra?.[0]?.tema || [];

          const temasFiltrados = temasAba.filter((tema) => {
            const titulo = tema.titulo?.trim().toUpperCase();
            return (
              titulo !==
              "6. RECEITA OPERACIONAL ANUAL / ARRECADAÇÃO MÍNIMA MENSAL"
            );
          });

          const slugsTemasPagina = temasFiltrados.map((t) =>
            normalizarTitulo(t.titulo)
          );

          const historicoMap = historico || historicoAnalise;

          const possuiAdequacaoNestaAba = Object.values(historicoMap).filter(
            (item) =>
              slugsTemasPagina.includes(normalizarTitulo(item.idCampoJson)) &&
              typeof item.dataSolicitacao === "string"
          );

          const temAdequacaoPendente = possuiAdequacaoNestaAba.some(
            (item) =>
              item.dataSolicitacao &&
              (!item.dataAdequacao || item.dataAdequacao === "")
          );

          setShowAdequacaoButton(temAdequacaoPendente);

          const deveDesabilitar = !(
            podeEditarLocal ||
            datafim === null ||
            temAdequacaoPendente
          );

          setFormDisabled(deveDesabilitar);
          setDataFim(datafim);
          setPodeEditar(podeEditarLocal);
        } catch (error) {
          console.error("Erro ao verificar se pode editar:", error);
        }
      };

      const receitaOperacionalLocal = (() => {
        const docsObrigatorios = rawJson.docsObrigatorios?.[0]?.tema || [];
        for (const tema of docsObrigatorios) {
          for (const criterio of tema.criterio || []) {
            for (const campo of criterio.campo || []) {
              if (campo.idCampo === "DRE-receita-operacional") {
                return campo.resposta;
              }
            }
          }
        }
        return null;
      })();

      setTopics(parsedTopics);
      if (typeof onTopicsLoaded === "function") {
        onTopicsLoaded(parsedTopics);
      }
      setSelectedOptions(selected);
      setUploadedFiles(arquivosCompletos);
      setReceitaOperacional(receitaOperacionalLocal);
      setFullJson(json);
      setIdResposta(id);
      setPerfilUsuario({
        responsavelPreenchimento: resposta.data?.responsavelPreenchimento || "",
        cargoResponsavel: resposta.data?.cargoResponsavel || "",
      });

      updateFormData("docBonusExtra", {
        selectedOptions: selected,
        uploadedFiles: arquivosCompletos,
      });

      carregarHistorico();
      VerificarSePodeEditar();

      setIsLoading(false);
    }, [isActive, resposta, documentos]);

    const handleOptionSelect = (topicId, option) => {
      const updatedOptions = { ...selectedOptions, [topicId]: option };
      setSelectedOptions(updatedOptions);

      updateFormData("docBonusExtra", {
        selectedOptions: updatedOptions,
        uploadedFiles,
      });

      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[topicId];
        return newErrors;
      });
    };

    const handleFileUpload = (campoNomeArquivo, files) => {
      const updated = { ...uploadedFiles, [campoNomeArquivo]: files };
      setUploadedFiles(updated);

      updateFormData("docBonusExtra", {
        selectedOptions,
        uploadedFiles: updated,
      });
    };

    const updateRespostasNoJson = (json) => {
      const updatedTemas = json.docsBonusExtra?.[0]?.tema.map((tema, idx) => {
        const topicId = idx + 1;
        const respostasTopico = selectedOptions[topicId];

        if (!respostasTopico) return tema;

        const respostaPrincipal = respostasTopico.resposta || "";
        const caminhos = respostasTopico.caminhos || {};

        const atualizarCampos = (campos, path = []) =>
          campos?.map((campo) => {
            if (campo.tipoCampo === "radio") {
              var pathKey = path.join(".");
              var isRootLevel = path.length === 0;

              var data = {
                alternativaNivel1: localStorage.getItem("alternativaNivel1"),
                alternativaNivel2: localStorage.getItem("alternativaNivel2"),
                alternativaNivel3: localStorage.getItem("alternativaNivel3"),
              };

              var respostaCampo = isRootLevel
                ? respostaPrincipal
                : caminhos[pathKey] || campo.resposta || "";

              if (campo.idCampo === "tipo-acao-internacional") {
                respostaCampo =
                  data.alternativaNivel1 !== ""
                    ? data.alternativaNivel1
                    : respostaCampo;
              }
              if (
                campo.idCampo === "tipo-acao-internacional" &&
                (respostaCampo === "NÃO" || respostaCampo === "SIM")
              ) {
                respostaCampo = "";
              }

              if (
                campo.idCampo === "missoes-ao-exterior" &&
                data.alternativaNivel2 !== ""
              ) {
                if (
                  data.alternativaNivel2 ===
                  "Realização de Missão internacional ou eventos no Brasil e exterior pelo Sindicato" ||
                  data.alternativaNivel2 ===
                  "Participação em Missões Internacionais organizadas pelo CIN"
                ) {
                  respostaCampo =
                    data.alternativaNivel2 !== ""
                      ? data.alternativaNivel2
                      : respostaCampo;
                } else if (
                  data.alternativaNivel2 === "Capacitação" ||
                  data.alternativaNivel2 ===
                  "Estudos de inteligência em Negócios Internacionais"
                ) {
                  respostaCampo = "";
                }
              } else if (
                campo.idCampo === "missoes-ao-exterior" &&
                data.alternativaNivel2 === "" &&
                respostaCampo !== ""
              ) {
                respostaCampo = "";
              }

              if (
                campo.idCampo === "participacao-empresas-associadas" &&
                data.alternativaNivel3 !== ""
              ) {
                respostaCampo =
                  data.alternativaNivel3 !== ""
                    ? data.alternativaNivel3
                    : respostaCampo;
              } else if (
                campo.idCampo === "participacao-empresas-associadas" &&
                data.alternativaNivel3 === "" &&
                respostaCampo !== ""
              ) {
                respostaCampo = "";
              }

              if (
                campo.idCampo === "assesoria-e-facilitacao" &&
                data.alternativaNivel2 !== ""
              ) {
                if (
                  data.alternativaNivel2 === "Capacitação" ||
                  data.alternativaNivel2 ===
                  "Estudos de inteligência em Negócios Internacionais"
                ) {
                  respostaCampo =
                    data.alternativaNivel2 !== ""
                      ? data.alternativaNivel2
                      : respostaCampo;
                } else {
                  respostaCampo = "";
                }
              } else if (
                campo.idCampo === "assesoria-e-facilitacao" &&
                data.alternativaNivel2 === "" &&
                respostaCampo !== ""
              ) {
                respostaCampo = "";
              }

              return {
                ...campo,
                resposta: respostaCampo,
                alternativa: campo.alternativa?.map((alt) => {
                  if (alt.campo) {
                    const novaPath = [...path, alt.valor || alt.titulo];
                    return {
                      ...alt,
                      campo: atualizarCampos(alt.campo, novaPath),
                    };
                  }
                  return alt;
                }),
              };
            }

            return campo;
          });

        return {
          ...tema,
          criterio: tema.criterio?.map((criterio) => ({
            ...criterio,
            campo: atualizarCampos(criterio.campo),
          })),
        };
      });

      return {
        ...json,
        docsBonusExtra: [
          {
            ...json.docsBonusExtra?.[0],
            tema: updatedTemas,
          },
        ],
      };
    };

    const filtrarUltimaVersao = (documentos = []) => {
      const extrairNomeBase = (nomeArquivo) => {
        return nomeArquivo
          ?.toLowerCase()
          .replace(/-?\d{4}(-\d+)?/i, "")
          .replace(/-v\d+/i, "")
          .replace(/\.(pdf|xlsx)$/i, "")
          .trim();
      };

      const extrairVersao = (nomeArquivo) => {
        const match = nomeArquivo.match(/-v(\d+)/i);
        return match ? parseInt(match[1], 10) : 1;
      };

      const agrupadoPorCampo = {};
      documentos.forEach((doc) => {
        const nomeBase = extrairNomeBase(doc.nomeArquivo);
        const versao = extrairVersao(doc.nomeArquivo);

        if (!nomeBase) return;

        if (!agrupadoPorCampo[nomeBase]) agrupadoPorCampo[nomeBase] = [];
        agrupadoPorCampo[nomeBase].push({ ...doc, versao });
      });

      const arquivosSelecionados = {};
      Object.entries(agrupadoPorCampo).forEach(([campo, arquivos]) => {
        const arquivoMaisAtual = arquivos.sort(
          (a, b) => b.versao - a.versao
        )[0];
        arquivosSelecionados[campo] = [arquivoMaisAtual];
      });

      return arquivosSelecionados;
    };

    const normalizeIdCampoJson = (str) =>
      str
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w-]/g, "");

    const handleAnalysisChange = (idCampoJson, valoresAtualizados) => {
      const key = normalizeIdCampoJson(idCampoJson);
      setHistoricoAnalise((prev) => ({
        ...prev,
        [key]: {
          ...prev[key],
          ...valoresAtualizados,
          id: prev[key]?.id || 0,
          idCampoJson: key,
        },
      }));
    };

    const handleEnviarAdequacao = async () => {
      const rawJson = resposta.data?.json;
      const json = typeof rawJson === "string" ? JSON.parse(rawJson) : rawJson;

      const temas = [
        ...(json?.docsObrigatorios?.[0]?.tema || []),
        ...(json?.docsBonus?.[0]?.tema || []),
        ...(json?.docsBonusExtra?.[0]?.tema || []),
      ];

      const temasFiltrados = temas.filter((tema) => {
        const titulo = tema.titulo?.trim().toUpperCase();
        return ![
          "6. RECEITA OPERACIONAL ANUAL / ARRECADAÇÃO MÍNIMA MENSAL",
          "7. EVOLUÇÃO RECEITA OPERACIONAL",
          "8. 80% DE RETENÇÃO DE ASSOCIADOS",
          "9. EVOLUÇÃO DO ASSOCIATIVISMO",
        ].includes(titulo);
      });

      const normalizarTitulo = (titulo) => {
        let tituloNormalizado = titulo
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^\w\s-]/g, "")
          .replace(/^\d+\s*[-.]*\s*/, "")
          .trim()
          .replace(/\s+/g, "-");

        if (tituloNormalizado === "dre---demonstracoes-do-resultado") {
          tituloNormalizado = "dre-demonstracoes-do-resultado";
        }
        if (
          tituloNormalizado ===
          "defesa-de-interesse-implementada-no-executivo-ou-legislativo"
        ) {
          tituloNormalizado =
            "defesa-de-interesse-implementada-no-executivo-e-legislativo";
        }

        return tituloNormalizado;
      };

      const slugsTemasPagina = temasFiltrados.map((t) =>
        normalizarTitulo(t.titulo)
      );

      const adequacoesRelevantes = Object.entries(historicoAnalise)
        .filter(([key, item]) => {
          const slugKey = normalizarTitulo(key);
          return (
            slugsTemasPagina.includes(slugKey) &&
            typeof item.dataSolicitacao === "string"
          );
        })
        .map(([_, item]) => item);

      const camposPendentes = adequacoesRelevantes.filter(
        (item) => item.adequacaoRealizada !== true
      );

      const todasAdequacoesMarcadas = adequacoesRelevantes.every(
        (item) => item.adequacaoRealizada === true
      );

      if (!todasAdequacoesMarcadas) {
        const camposFaltando = camposPendentes.map((item) => ({
          tema: item.tema,
          titulo: item.titulo || item.idCampoJson,
        }));

        setToastData({
          show: true,
          message: (
            <>
              <p>Você precisa marcar as adequações dos seguintes campos:</p>
              <ul style={{ marginTop: 6, marginBottom: 4, paddingLeft: 20 }}>
                {camposFaltando.map((campo, idx) => (
                  <li key={campo.titulo + idx} style={{ marginBottom: 4 }}>
                    <strong>{campo.tema ? campo.tema + ": " : ""}</strong>
                    <span style={{ textTransform: "capitalize" }}>
                      {campo.titulo.replace(/-/g, " ")}
                    </span>
                  </li>
                ))}
              </ul>
            </>
          ),
          type: "error",
        });
        return;
      }

      const temArquivoPendente = Object.values(uploadedFiles)
        .flat()
        .some((file) => file instanceof File);

      if (temArquivoPendente) {
        setToastData({
          show: true,
          message:
            "Existem arquivos pendentes. Clique em SALVAR para persistir os arquivos antes de enviar a adequação.",
          type: "error",
        });
        return;
      }

      const adequacoesValidas = Object.values(historicoAnalise).filter(
        (item) =>
          (item.obsAnalista ||
            item.obsSindicato ||
            item.adequacaoRealizada !== undefined) &&
          item.id > 0
      );

      try {
        setLoading(true);

        const jsonAtualizado = updateRespostasNoJson(fullJson);

        const receitaAtualizada = (() => {
          try {
            const temas2 = jsonAtualizado?.docsObrigatorios?.[0]?.tema || [];
            for (const tema of temas2) {
              for (const criterio of tema.criterio || []) {
                for (const campo of criterio.campo || []) {
                  if (campo.idCampo === "DRE-receita-operacional") {
                    return campo.resposta;
                  }
                }
              }
            }
            return null;
          } catch (err) {
            console.error("❌ Erro ao extrair receitaAtualizada:", err);
            return null;
          }
        })();

        const responsavelPreenchimento =
          localStorage.getItem("responsavelQuestionaro") || "";
        const cargoResponsavel = localStorage.getItem("cargoResponsavel") || "";

        const payload = {
          Json: jsonAtualizado,
          ResponsavelPreenchimento: responsavelPreenchimento,
          CargoResponsavel: cargoResponsavel,
          ReceitaOperacional: receitaAtualizada,
          PercentualConclusao: 0,
          AdequacaoCamposQuestionarioJson: JSON.stringify(
            adequacoesValidas.map((item) => ({
              Id: item.id,
              ObsSindicato: item.obsSindicato || "",
              AdequacaoRealizada: item.adequacaoRealizada === true,
              IdCampoJson: item.idCampoJson,
              IdQuestionarioResposta: idResposta,
            }))
          ),
        };

        await enviarAdequacao(idResposta, payload);

        const documentosAtualizados = await getDocumentosByRespostaId(
          idResposta
        );
        const arquivosAtualizados = filtrarUltimaVersao(documentosAtualizados);
        setUploadedFiles(arquivosAtualizados);

        setToastData({
          show: true,
          message: "Adequação enviada com sucesso!",
          type: "success",
        });

        setTimeout(() => window.location.reload(), 500);
      } catch (error) {
        console.error("❌ Erro ao enviar adequação:", error);
        setToastData({
          show: true,
          message: "Erro ao enviar adequação!",
          type: "error",
        });
      } finally {
        setLoading(false);
      }
    };

    const handleSave = async () => {
      try {
        setLoading(true);

        updateFormData("docBonusExtra", { selectedOptions, uploadedFiles });

        const updatedJson = updateRespostasNoJson(fullJson);

        const arquivosParaEnvio = Object.values(uploadedFiles)
          .flat()
          .filter((file) => file instanceof File);

        const receitaAtualizada = (() => {
          const temas2 = updatedJson?.docsObrigatorios?.[0]?.tema || [];
          for (const tema of temas2) {
            for (const criterio of tema.criterio || []) {
              for (const campo of criterio.campo || []) {
                if (campo.idCampo === "DRE-receita-operacional") {
                  const valor = parseFloat(
                    campo.resposta?.toString().replace(",", ".")
                  );
                  return isNaN(valor) ? 0 : valor;
                }
              }
            }
          }
          return 0;
        })();

        await salvarRespostaComArquivos(
          idResposta,
          updatedJson,
          receitaAtualizada,
          arquivosParaEnvio,
          {
            responsavelPreenchimento:
              dadosCadastros?.responsavelPreenchimento || "",
            cargoResponsavel: dadosCadastros?.cargoResponsavel || "",
          }
        );

        const documentosAtualizados = await getDocumentosByRespostaId(
          idResposta
        );
        const arquivosAtualizados = filtrarUltimaVersao(documentosAtualizados);

        setUploadedFiles(arquivosAtualizados);
        updateFormData("docBonusExtra", {
          selectedOptions,
          uploadedFiles: arquivosAtualizados,
        });

        localStorage.setItem("abaAtivaMeritocracia", "docBonusExtra");

        setToastData({
          show: true,
          message: "Documentos bônus extra salvos com sucesso!",
          type: "success",
        });

        return {
          show: true,
          message: "Documentos bônus extra salvos com sucesso!",
          type: "success",
        };
      } catch (error) {
        console.error("❌ Erro ao salvar Documentos Bônus Extra:", error);
        setToastData({
          show: true,
          message: "Erro ao salvar Documentos Bônus Extra.",
          type: "error",
        });

        return {
          show: true,
          message: "Erro ao salvar Documentos Bônus Extra.",
          type: "error",
        };
      } finally {
        setLoading(false);
      }
    };

    useImperativeHandle(ref, () => ({ handleSave }));

    const handleSubmit = async () => {
      const saveResult = await handleSave();
      if (saveResult?.type === "success") {
        setShowConfirmation(true);
      }
    };

    const handleCancel = () => setShowConfirmation(false);

    const modoAdequacao = Object.values(historicoAnalise || {}).some(
      (item) =>
        typeof item?.dataSolicitacao === "string" &&
        item?.adequacaoRealizada !== true
    );

    return (
      <Container className="doc-bonus-extra-container">
        {loading ? (
          <PageLoading minHeight="60vh" />
        ) : !showConfirmation ? (
          <>
            {!podeEditar && dataFim !== null && !showAdequacaoButton && (
              <Alert variant="warning" className="mt-3">
                Você não pode mais editar os dados de Documentos Obrigatórios.
              </Alert>
            )}

            <div className="shipping-tab-header">
              <h1 className="doc-bonus-title">DOCUMENTOS BÔNUS EXTRA</h1>

              {showToggleAll && (
                <button
                  type="button"
                  className="shipping-toggle-all"
                  onClick={onToggleAll}
                  aria-label={isAllOpen ? "Recolher tudo" : "Expandir tudo"}
                  title={
                    isAllOpen
                      ? "Recolher todos os tópicos"
                      : "Expandir todos os tópicos"
                  }
                >
                  {isAllOpen ? "Recolher tudo" : "Expandir tudo"}
                </button>
              )}
            </div>

            {isLoading ? (
              <PageLoading minHeight="60vh" />
            ) : (
              <>
                {topics.map((topic) => (
                  <Topic
                    key={topic.id}
                    data={topic}
                    onOptionSelect={handleOptionSelect}
                    onFileUpload={handleFileUpload}
                    hasError={!!errors[topic.id]}
                    idResposta={idResposta}
                    uploadedFiles={uploadedFiles}
                    selectedOptions={selectedOptions}
                    disabled={formDisabled}
                    historico={historicoAnalise}
                    onAnalysisChange={handleAnalysisChange}
                    modoAdequacao={modoAdequacao}
                    isOpen={openByTopic[topic.idCampoJson] === true}
                    onToggle={onToggleOne ? () => onToggleOne(topic.idCampoJson) : undefined}
                  />
                ))}

                <div className="buttons-container">
                  <SaveSubmitButtons
                    onSave={handleSave}
                    onAdequacaoSubmit={handleEnviarAdequacao}
                    onSubmit={handleSubmit}
                    podeEditar={podeEditar}
                    temAdequacao={showAdequacaoButton}
                    showSave={true}
                    showSubmit={true}
                  />
                </div>

                <NotificationToast
                  show={toastData.show}
                  onClose={() => setToastData((prev) => ({ ...prev, show: false }))}
                  message={toastData.message}
                  type={toastData.type}
                />
              </>
            )}
          </>
        ) : (
          <ConfirmacaoDocumentacao
            onCancel={handleCancel}
            onSubmit={handleSubmit}
          />
        )}
      </Container>
    );
  }
);

export default DocBonusExtraTab;